module.exports = __webpack_public_path__ + "static/media/completion_spread.b875e097.mp4";